import { Component, Input, NgZone } from '@angular/core';
import { App } from 'ionic-angular';
import { User } from '../../providers/user';
import { Events } from 'ionic-angular';
import { ImagePicker, Camera, Crop } from 'ionic-native';


@Component({
    selector: 'account-photo-manager',
    templateUrl: 'account-photo-manager.html'
})
export class AccountPhotoManager {
    @Input() profile: any;
    photo64: string;

    constructor(
        public app: App,
        public zone: NgZone,
        public user: User,
        public events: Events
    ) {
        this.fetchProfile();
    }

    /**
     * 
     * 
     * 
     * @memberOf AccountPhotoManager
     */
    picFromCamera() {
        let options = {
            quality: 50,
            cameraDirection: 1,
            correctOrientation: true,
            // allowEdit: true,
            // sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
            // mediaType: Camera.MediaType.ALLMEDIA,
            destinationType: Camera.DestinationType.FILE_URI
        };
        Camera.getPicture(options).then((imageData) => {
            Crop.crop(imageData, { quality: 75 })
                .then((newImage) => {
                    // upload image and save profile
                    this.user.profileImageStorage(newImage).then((photoURL: string) => {
                        this.user.profile().updateProfile({
                            photoURL: photoURL
                        });
                    });
                    // display image imediatly
                    this.user.getProfileImage64().then((base64image: string) => {
                        this.photo64 = base64image;                        
                    }).catch(e => {
                        console.error(e);
                    });
                }, error => console.error("Error cropping image", error));
        }, (err) => {
            // Handle error
        });
    }


    /**
     * 
     * 
     * 
     * @memberOf AccountPhotoManager
     */
    picFromDevice() {
        let options = "";
        ImagePicker.getPictures(options).then((results) => {
            for (var i = 0; i < results.length; i++) {
                console.log('Image URI: ' + results[i]);
                try {
                    Crop.crop(results[i], { quality: 75 }).then((newImage) => {
                        // upload image and save profile
                        this.user.profileImageStorage(newImage).then((photoURL: string) => {
                            this.user.profile().updateProfile({
                                photoURL: photoURL
                            });
                        });
                        // display image imediatly
                        this.user.getProfileImage64().then((base64image: string) => {
                            this.photo64 = base64image;
                        }).catch(e => {
                            console.error(e);
                        });
                    }).catch((e) => {
                        console.error("Error cropping image: ");
                        console.error(e);
                    });
                } catch (e) {
                    console.error(e);
                }
            }
        }, (e) => {
            console.error(e);
        });
    }

    fetchProfile() {
        let currentUser = this.user.profile();
        this.zone.run(() => {
            this.profile = currentUser;
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/account-photo-manager/account-photo-manager.ts